import type {RuleType} from 'services/formValidationHelpers'
import type {OpsOrderType} from 'types/orderTypes'
import {requiredValidationRules} from './validationRulesConstants'

type LoanDetailConfigId = Extract<
  keyof OpsOrderType,
  | 'clientLoanNumber'
  | 'clientLenderName'
  | 'borrowerName'
  | 'clientTrackingId'
  | 'clientTrackingId2'
  | 'clientTrackingId3'
  | 'purpose'
  | 'investor'
  | 'customerNotes'
>

export type LoanDetailConfigType = {
  id: LoanDetailConfigId
  label: string
  fullWidth?: boolean
  placeholder?: string
  validation?: RuleType[]
} & ({type: 'text'} | {type: 'select'; options: {value: string; label: string}[]})

export const LOAN_DETAILS_FIELD_CONFIG: LoanDetailConfigType[] = [
  {
    id: 'clientLoanNumber',
    type: 'text',
    label: 'Loan #',
    validation: [...requiredValidationRules]
  },
  {
    id: 'clientLenderName',
    type: 'text',
    label: 'Lender or Client Name',
    validation: [...requiredValidationRules]
  },
  {
    id: 'borrowerName',
    type: 'text',
    label: 'Borrower Name',
    validation: [...requiredValidationRules]
  }
]

export const PurposeOptions = [
  {label: 'Purchase', value: 'PURCHASE'},
  {label: 'Refinance', value: 'REFINANCE'},
  {label: 'Pre-funding Decision', value: 'PREFUNDING_DECISION'}
]

export const LOAN_DETAILS_OPTIONAL_FIELD_CONFIG: LoanDetailConfigType[] = [
  {
    id: 'purpose',
    type: 'select',
    options: PurposeOptions,
    label: 'Purpose'
  },
  {
    id: 'investor',
    type: 'text',
    label: 'Investor'
  },
  {
    id: 'clientTrackingId',
    type: 'text',
    label: 'Tracking ID 1'
  },
  {
    id: 'clientTrackingId2',
    type: 'text',
    label: 'Tracking ID 2'
  },
  {
    id: 'clientTrackingId3',
    type: 'text',
    label: 'Tracking ID 3'
  },
  {
    id: 'customerNotes',
    type: 'text',
    label: 'Customer Notes',
    fullWidth: true
  }
]
